import { PropsWithChildren } from 'react';

import { useIsPDF } from '../internal/useIsPDF.js';

export function WebOnly(props: PropsWithChildren) {
  const { children } = props;
  return useIsPDF() ? null : <>{children}</>;
}
